/** Elements a browser focuses on mousedown by itself. */
const FOCUSABLE =
  "a[href], button, input, select, textarea, summary, iframe, [contenteditable]:not([contenteditable='false']), [tabindex]";

/**
 * The nearest element from `target` up to, not including, `box` that scrolls
 * overflowing content and that a click would not focus. Null when the click
 * already focuses something nearer, or `target` is outside `box` (a nested
 * dialog is portaled out of the DOM but still bubbles through the React tree).
 */
export function findUnfocusableScrollBody(target: EventTarget | null, box: Element): Element | null {
  if (!(target instanceof Element) || !box.contains(target)) return null;
  for (let element: Element | null = target; element && element !== box; element = element.parentElement) {
    if (element.matches(FOCUSABLE)) return null;
    const { overflowY } = getComputedStyle(element);
    if ((overflowY === "auto" || overflowY === "scroll") && element.scrollHeight > element.clientHeight) {
      return element;
    }
  }
  return null;
}

/**
 * Call on pointerdown: the mousedown that follows then focuses the scroll body
 * instead of `box`, and PageDown and the arrow keys scroll what the user clicked.
 */
export function makeScrollBodyFocusable(target: EventTarget | null, box: Element): void {
  const body = findUnfocusableScrollBody(target, box);
  if (!body) return;
  body.setAttribute("tabindex", "-1");
  body.classList.add("outline-none");
}
